import { BreadcrumbTemplateEnum, Breadcrumbs, Page, PageHeader, PageInner, PageSection } from "@app/shared";
import { TileProps } from "@app/shared/interfaces/dashboard";
import * as React from "react";
import { Link } from "react-router-dom";
import { RoleRestricted, Roles } from "@app/user";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QesIcon } from "@app/shared/icons/QESIcon";

const tiles: TileProps[] = [
  {
    allowedRoles: [Roles.PERFORMANCE_MONITOR],
    icon: QesIcons.FontAwesome.Desktop,
    route: "ui-statistics",
    title: "UI Statistics"
  },
  {
    allowedRoles: [Roles.PERFORMANCE_MONITOR],
    icon: QesIcons.FontAwesome.Server,
    route: "job-statistics",
    title: "Job Statistics"
  },
];

export const PerformanceDashboard: React.FC<React.PropsWithChildren<unknown>> = () => {

  return (
    <Page documentTitle="Performance Dashboard">
      <Breadcrumbs template={BreadcrumbTemplateEnum.Performance} items={[]}
      />
      <PageInner>
        <PageHeader iconName={QesIcons.FontAwesome.Rocket} title="Performance Dashboard" disableHR={false} />
        <PageSection>
          <div className="container mt-3">
            {tiles.map((tile) => <Tile key={tile.title} icon={tile.icon} route={tile.route} title={tile.title} allowedRoles={tile.allowedRoles} />)}
          </div>
        </PageSection>
      </PageInner>
    </Page>
  );
};

const Tile: React.FC<React.PropsWithChildren<TileProps>> = ({ icon, route = "#", title, allowedRoles }) => {
  return (
    <RoleRestricted allowedRoles={allowedRoles}>
      <Link to={`/performance/${route}`} className="dashboard-tile col-4">
        <QesIcon iconName={icon} width="27" height="27" classNames="mb-2" isDecorative={true} />
        <h6>{title}</h6>
      </Link>
    </RoleRestricted>
  );
};
